import eventBus from '@eventBus/index';

import { EventBusTypes } from '../../enums/eventBusTypes.enum';
import { EventBusCallbackType } from '../../interfaces/callback.interface';
import { EmptyFunction } from '../../interfaces/emptyFunction.interface';
import { IRoundsManipulationProps } from './roundsManipulation.interface';

const eventName = EventBusTypes.ROUNDS_MANIPULATION;

const subscribe = (
  callback: EventBusCallbackType<IRoundsManipulationProps>
): EmptyFunction => {
  return eventBus.subscribe<IRoundsManipulationProps>(eventName, callback);
};

const broadcast = (data: IRoundsManipulationProps): void => {
  eventBus.broadcast<IRoundsManipulationProps>(eventName, data);
};

export default {
  subscribe,
  broadcast,
};
